export class LoginApiResponseModel {
  apiName: string;
  httpMethod: string;
  endPoint: string;
  userNameField: string;
  passwordField: string;
  encryptionType: string;
  logo: string;
  appKey: string;
  companyId: string;
  companyCode: string;
  affiliateId: string;

  static requireFields(): string[] {
    return [
      'logo', 'appKey', 'affiliateId', 'companyCode',
      'apiName', 'httpMethod', 'endPoint',
      'userNameField', 'passwordField', 'encryptionType',
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/model/login/login-api-response.model.ts